export function handleScroll(headers: NodeListOf<Element>, contentItems: NodeListOf<Element>) {
		const handleScrollEvent = () => {
				const scrollDistance = window.scrollY;
				headers.forEach((el, i) => {
						if (el instanceof HTMLElement && el.offsetTop - 125 <= scrollDistance) {
								contentItems.forEach(link => {
										if (link instanceof HTMLAnchorElement && link.getAttribute('href')?.replace('#', '') !== el.id) {
												link.classList.remove('active-id');
										}
								});
								contentItems[i].classList.add('active-id');
						}
				});
		};

		window.addEventListener('scroll', handleScrollEvent);

		return () => {
				window.removeEventListener('scroll', handleScrollEvent);
		};
}